export function timePerKmToSeconds(pace?: string): number | null {
  if (!pace) return null;
  const m = pace.match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return null;
  const minutes = parseInt(m[1], 10);
  const seconds = parseInt(m[2], 10);
  if (isNaN(minutes) || isNaN(seconds) || seconds >= 60) return null;
  return minutes * 60 + seconds;
}

export function secondsToTimePerKm(secondsNum: number): string {
  const s = Math.round(Math.max(0, secondsNum));
  const minutes = Math.floor(s / 60);
  const seconds = s % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
}